import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import noop from 'lodash/noop';
import isNumber from 'lodash/isNumber';
import { CountLabel } from '@creditflowresearch/uilib/Badge/CountLabel';
import { useTabsContext } from './TabsContextProvider';
import { TOKENS } from '@creditflowresearch/uilib/constants/tokens';
import styles from './tabs.module.scss';
interface IProps {
  tabFor: string | number | symbol,
  children: React.ReactNode,
  className?: string,
  activeClassName?: string,
  disabledClassName?: string,
  name?: string,
  selected?: boolean,
  disabled?: boolean,
  onClick?: React.MouseEventHandler<HTMLButtonElement>,
  focusOnSelect?: boolean,
  counter?: number,
}
const Tab = ({
  tabFor,
  children,
  className,
  activeClassName,
  disabledClassName,
  name,
  selected = false,
  disabled = false,
  onClick = noop,
  focusOnSelect = false,
  counter,
}: IProps) => {
  const tabRef = useRef<HTMLButtonElement>(null);
  const context = useTabsContext();
  const isSelected = context?.isSelected(tabFor) ?? selected;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    !disabled && context?.select(tabFor);
    onClick(event);
  };

  useEffect(() => {
    if (focusOnSelect && context?.isSelected(tabFor)) {
      tabRef.current?.focus();
    }
  }, [context?.selectedTabId]);

  return (
    <button
      ref={ tabRef }
      type="button"
      role="tab"
      aria-selected={ isSelected }
      className={ cn(styles.tab, className, {
        [activeClassName || styles.isTabActive]: isSelected,
        [disabledClassName]: disabled,
      }) }
      data-test={ name }
      onClick={ handleClick }
    >
      { children }
      { isNumber(counter) && (
        <CountLabel
          className={ styles.countLabel }
          totalCount={ counter }
          maxTotalCount={ 99 }
          canShowCount
          backgroundColor={ TOKENS.surface.neutralBadge }
        />
      ) }
    </button>
  );
};

export default Tab;
